import React, { useState, useEffect } from "react";

const DateFilter = ({ dateFrom, setDateFrom, dateTo, setDateTo, defaultType = "all" }) => {
    const [filterType, setFilterType] = useState(defaultType);

    useEffect(() => {
        const formatDateLocal = (date) => {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            return `${year}-${month}-${day}`;
        };

        const today = new Date();
        let fromDate = new Date();

        if (filterType === "today") {
            setDateFrom(formatDateLocal(today));
            setDateTo(formatDateLocal(today));
        }
        if (filterType === "week") {
            fromDate.setDate(today.getDate() - 7);
            setDateFrom(formatDateLocal(fromDate));
            setDateTo(formatDateLocal(today));
        }
        if (filterType === "month") {
            fromDate.setMonth(today.getMonth() - 1);
            setDateFrom(formatDateLocal(fromDate));
            setDateTo(formatDateLocal(today));
        }
        if (filterType === "all") {
            setDateFrom("");
            setDateTo("");
        }
        if (filterType === "custom") {
            setDateFrom("");
            setDateTo("");
        }
    }, [filterType, setDateFrom, setDateTo]);

    return (
        <div className="w-full flex justify-end gap-4 flex-col md:flex-row items-end md:items-center px-[1.5vmax] mt-[1vmax]">
            {/* Show dropdown if not custom */}
            {filterType !== "custom" && (
                <div className="flex bg-white dark:bg-slate-900 border border-zinc-200/80 dark:border-slate-700 shadow-sm gap-2 h-11 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-sky-500/20 focus-within:border-sky-500 dark:focus-within:border-sky-400 transition-all">
                    <select
                        className="pl-4 pr-10 py-2 rounded-xl outline-none bg-transparent text-sm font-medium text-zinc-700 dark:text-slate-200 appearance-none cursor-pointer"
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                        style={{
                            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
                            backgroundPosition: `right 0.5rem center`,
                            backgroundRepeat: `no-repeat`,
                            backgroundSize: `1.5em 1.5em`,
                        }}
                    >
                        <option value="all">All Time</option>
                        <option value="today">Today</option>
                        <option value="week">Last Week</option>
                        <option value="month">Last Month</option>
                        <option value="custom">Custom Date</option>
                    </select>

                    <div className="bg-gradient-to-br from-sky-400 to-sky-600 flex items-center justify-center px-4">
                        <i className="fa-solid fa-calendar-alt text-white text-sm"></i>
                    </div>
                </div>
            )}

            {/* Show From/To if custom */}
            {filterType === "custom" && (
                <div className="flex flex-col md:flex-row gap-4 items-stretch md:items-center">
                    {/* From */}
                    <div className="flex items-center gap-2">
                        <span className="text-xs font-bold text-zinc-500 dark:text-slate-400 uppercase tracking-wider">From:</span>
                        <div className="flex bg-white dark:bg-slate-900 border border-zinc-200/80 dark:border-slate-700 shadow-sm h-11 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-sky-500/20 focus-within:border-sky-500 dark:focus-within:border-sky-400 transition-all">
                            <input
                                type="date"
                                className="pl-4 pr-2 rounded-xl bg-transparent text-sm font-medium text-zinc-700 dark:text-slate-200 outline-none"
                                value={dateFrom}
                                onChange={(e) => setDateFrom(e.target.value)}
                            />
                            <div className="bg-gradient-to-br from-sky-400 to-sky-600 flex items-center justify-center px-3">
                                <i className="fa-solid fa-calendar text-white text-sm"></i>
                            </div>
                        </div>
                    </div>

                    {/* To */}
                    <div className="flex items-center gap-2">
                        <span className="text-xs font-bold text-zinc-500 dark:text-slate-400 uppercase tracking-wider">To:</span>
                        <div className="flex bg-white dark:bg-slate-900 border border-zinc-200/80 dark:border-slate-700 shadow-sm h-11 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-sky-500/20 focus-within:border-sky-500 dark:focus-within:border-sky-400 transition-all">
                            <input
                                type="date"
                                className="pl-4 pr-2 rounded-xl bg-transparent text-sm font-medium text-zinc-700 dark:text-slate-200 outline-none"
                                value={dateTo}
                                onChange={(e) => setDateTo(e.target.value)}
                            />
                            <div className="bg-gradient-to-br from-sky-400 to-sky-600 flex items-center justify-center px-3">
                                <i className="fa-solid fa-calendar text-white text-sm"></i>
                            </div>
                        </div>
                    </div>

                    {/* Back to presets button */}
                    <button
                        onClick={() => setFilterType("month")}
                        className="cursor-pointer text-white bg-zinc-900 dark:bg-sky-600 hover:bg-zinc-800 dark:hover:bg-sky-500 w-11 h-11 rounded-xl flex items-center justify-center transition-colors shadow-sm"
                        title="Back to presets"
                    >
                        <i className="fa-solid fa-arrows-rotate text-sm"></i>
                    </button>
                </div>
            )}
        </div>
    );
};

export default DateFilter;
